var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 39,
    viewBox: "0 0 107 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5094 38.9926C26.0923 38.9926 31.4081 33.347 31.4081 26.6558C31.4081 13.1603 12.5345 16.8195 12.5345 12.437C12.5345 11.1825 13.6073 10.137 16.9724 10.137C19.9473 10.137 23.1173 11.0257 26.4824 12.8552L29.9451 3.91629C26.3849 1.77309 21.6542 0.727539 17.0699 0.727539C6.48708 0.727539 1.17126 6.26861 1.17126 13.0644C1.17126 26.7081 20.0449 22.9879 20.0449 27.5966C20.0449 28.8513 18.8743 29.5832 15.6069 29.5832C11.8517 29.5832 7.55988 28.2763 4.34109 26.2376L0.634766 35.2288C4.04864 37.4766 9.8034 38.9926 15.5094 38.9926ZM59.4503 38.1562H72.7644L58.4263 17.6646L72.0816 1.56398H59.5479L48.331 14.8418V1.56398H37.0165V38.1562H48.331V29.1127L50.9157 26.0285L59.4503 38.1562ZM107 1.56398H95.8809L88.8582 14.2145L81.8841 1.56398H69.7406L82.6157 24.7216V38.1562H94.1252V24.8784L107 1.56398Z",
    fill: "#FDFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyWhiteLogo);
export default __webpack_public_path__ + "static/media/skyWhiteLogo.141ad2552be93fc9c95be93a0e3907cf.svg";
export { ForwardRef as ReactComponent };